export const TREES_LOADED = 'TREES_LOADED';
export const MATCHING_CATEGORY = 'MATCHING_CATEGORY';
export const MATCHING_CATEGORY_DELETE = 'MATCHING_CATEGORY_DELETE';


export const treesLoaded = (trees = {end_categories: [], matching_categories: []} ) => {
	return {
		type: TREES_LOADED,
		end_categories: trees.end_categories,
		matching_categories: trees.matching_categories,
	};
};

export const matchingCategory = (category) => {
	return {
		type: MATCHING_CATEGORY,
		category
	};
};

export const matchingCategoryDelete = (category) => {
	return {
		type: MATCHING_CATEGORY_DELETE,
		category
	};
};




// WEBPACK FOOTER //
// ./frontend/actions/categoryMatching.js